/*
 * Copyright (c) 2010, 2024 BSI Business Systems Integration AG
 *
 * This program and the accompanying materials are made
 * available under the terms of the Eclipse Public License 2.0
 * which is available at https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 */
/**
 * Map of shared variables (shared between the SharedContext of the ClientSession and the browser Session instance) with property name and data type for that property.
 * More properties can be added using TypeScript declaration merging.
 */
export interface SharedVariables {
}
